"use client";

import React, { useEffect, useMemo, useState } from "react";
import Button from "../../../../../components/Button";
import Dropdown from "../../../../../components/Dropdown";
import FormInput from "../../../../../components/FormInput";
import modalStyles from "../../../../../css/modal.module.css";
import pageStyles from "../../css/addDoctore.module.css";
import popupStyles from "../css/practitionerDetailsModal.module.css";
import { getPractitionerTypes, createPractitioner, updatePractitioner } from "../../../../../api/profile/add_doctor";

export default function PractitionerDetailsModal({
  isOpen,
  onClose,
  doctorForm,
  setDoctorForm,
  onSaved,
  onRequestDisable,
  showDisable = false,
  disableLabel = "Disable",
  compact = false,
  readOnly = false,
  practitionerId = null,
}) {
  const [types, setTypes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    (async () => {
      try {
        const rows = await getPractitionerTypes();
        setTypes(rows);
      } catch (_) {
        setTypes([]);
      }
    })();
  }, [isOpen]);

  const typeOptions = useMemo(() => {
    const dbNames = types.map((t) => t?.practicetype).filter(Boolean);
    return [...dbNames, "Other"];
  }, [types]);

  if (!isOpen) return null;

  const selectedTypeIsOther = doctorForm.practiceType === "Other";

  return (
    <div id="modal-popup" className={modalStyles.modalPopup} onClick={onClose}>
      <div
        className={`${modalStyles.modalContent} ${compact ? modalStyles.modalContentNarrow : popupStyles.modalContentWidth}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={pageStyles.modalPanel}>
          <button className={modalStyles.closeBtn} onClick={onClose} aria-label="Close">
            ×
          </button>

          <h2 className={pageStyles.modalTitle}>Practitioner Details</h2>
          <div className={popupStyles.formGrid}>
            <div className={popupStyles.leftCol}>
              <div className={pageStyles.fieldBlock}>
                <FormInput
                  label="Surname"
                  type="text"
                  name="surname"
                  value={doctorForm.surname}
                  onChange={(e) => setDoctorForm((p) => ({ ...p, surname: e.target.value }))}
                />
              </div>
              <div className={popupStyles.inlineRow}>
                <div className={pageStyles.fieldBlock}>
                  <FormInput
                    label="First Name(s)"
                    type="text"
                    name="firstname"
                    value={doctorForm.firstNames}
                    onChange={(e) => setDoctorForm((p) => ({ ...p, firstNames: e.target.value }))}
                  />
                </div>
                <div className={popupStyles.smallControl}>
                  <label className={popupStyles.dropdownLabel}>Title</label>
                  <Dropdown
                    options={["Mr", "Miss", "Ms", "Mrs", "Dr", "Prof"]}
                    value={doctorForm.title}
                    onChange={(v) => setDoctorForm((p) => ({ ...p, title: v }))}
                  />
                </div>
              </div>
              <FormInput
                label="Doctor Cell Number"
                type="text"
                name="contactnumber"
                value={doctorForm.contact}
                onChange={(e) => {
                  const v = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
                  setDoctorForm((p) => ({ ...p, contact: v }));
                }}
              />
              <FormInput
                label="Email Address"
                type="email"
                name="email"
                value={doctorForm.email}
                onChange={(e) => setDoctorForm((p) => ({ ...p, email: e.target.value }))}
              />
              <label>Practice Address</label>
              <FormInput
                label="Street"
                type="text"
                name="practiceStreet"
                value={doctorForm.practiceStreet || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, practiceStreet: e.target.value }))}
              />
              <FormInput
                label="Suburb"
                type="text"
                name="practiceSuburb"
                value={doctorForm.practiceSuburb || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, practiceSuburb: e.target.value }))}
              />
              <FormInput
                label="City"
                type="text"
                name="practiceCity"
                value={doctorForm.practiceCity || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, practiceCity: e.target.value }))}
              />
              <FormInput
                label="Postal Code"
                type="text"
                name="practicePostalCode"
                value={doctorForm.practicePostalCode || ""}
                onChange={(e) => {
                  const v = (e.target.value || "").replace(/\D/g, "").slice(0, 4);
                  setDoctorForm((p) => ({ ...p, practicePostalCode: v }));
                }}
                maxLength={4}
              />
            </div>
            <div className={popupStyles.rightCol}>
              <label>Postal Address</label>
              <FormInput
                label="Street"
                type="text"
                name="postalStreet"
                value={doctorForm.postalStreet || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, postalStreet: e.target.value }))}
              />
              <FormInput
                label="Suburb"
                type="text"
                name="postalSuburb"
                value={doctorForm.postalSuburb || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, postalSuburb: e.target.value }))}
              />
              <FormInput
                label="City"
                type="text"
                name="postalCity"
                value={doctorForm.postalCity || ""}
                onChange={(e) => setDoctorForm((p) => ({ ...p, postalCity: e.target.value }))}
              />
              <FormInput
                label="Postal Code"
                type="text"
                name="postalPostalCode"
                value={doctorForm.postalPostalCode || ""}
                onChange={(e) => {
                  const v = (e.target.value || "").replace(/\D/g, "").slice(0, 4);
                  setDoctorForm((p) => ({ ...p, postalPostalCode: v }));
                }}
                maxLength={4}
              />
              <FormInput
                label="Practice Contact Number"
                type="text"
                name="practicecontactnumber"
                value={doctorForm.practiceContact || ""}
                onChange={(e) => {
                  const v = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
                  setDoctorForm((p) => ({ ...p, practiceContact: v }));
                }}
              />
              <FormInput
                label="Practice Number"
                type="text"
                name="practiceNumber"
                value={doctorForm.practiceNumber}
                onChange={(e) => setDoctorForm((p) => ({ ...p, practiceNumber: e.target.value }))}
              />
              <FormInput
                label="Speciality"
                type="text"
                name="speciality"
                value={doctorForm.speciality}
                onChange={(e) => setDoctorForm((p) => ({ ...p, speciality: e.target.value }))}
              />
              <label className={popupStyles.dropdownLabel}>Practice Type</label>
              <Dropdown
                options={typeOptions}
                value={doctorForm.practiceType}
                onChange={(v) =>
                  setDoctorForm((p) => ({
                    ...p,
                    practiceType: v,
                    practiceTypeOther: v === "Other" ? (p.practiceTypeOther || "") : "",
                    practiceTypeId: v !== "Other" ? (types.find(t => t?.practicetype === v)?.practicetypeid ?? null) : null,
                  }))
                }
              />
              {selectedTypeIsOther && (
                <div className={popupStyles.practiceTypeOtherWrapper}>
                  <FormInput
                    label="Specify Practice Type"
                    name="practiceTypeOther"
                    type="text"
                    value={doctorForm.practiceTypeOther || ""}
                    onChange={(e) => setDoctorForm((p) => ({ ...p, practiceTypeOther: e.target.value }))}
                  />
                </div>
              )}
            </div>
          </div>

          <div className={pageStyles.modalActionsCenter}>
            {!readOnly && (
              <Button
                variant="primary"
                className={pageStyles.modalSaveBtn}
                disabled={saving}
                onClick={async () => {
                  if (saving) return;
                  setErrorMsg("");
                  const firstname = (doctorForm.firstNames || "").trim();
                  const surname = (doctorForm.surname || "").trim();
                  const practicenumber = (doctorForm.practiceNumber || "").trim();
                  if (!firstname || !surname || !practicenumber) {
                    setErrorMsg("Firstname, Surname and Practice Number are required");
                    return;
                  }

                  const contactnumber = (doctorForm.contact || "").replace(/\D/g, "");
                  const practicecontactnumber = (doctorForm.practiceContact || "").replace(/\D/g, "");
                  const practiceaddress = [doctorForm.practiceStreet, doctorForm.practiceSuburb, doctorForm.practiceCity, doctorForm.practicePostalCode]
                    .map((s) => (s || "").trim())
                    .filter(Boolean)
                    .join(", ");
                  const postaladdress = [doctorForm.postalStreet, doctorForm.postalSuburb, doctorForm.postalCity, doctorForm.postalPostalCode]
                    .map((s) => (s || "").trim())
                    .filter(Boolean)
                    .join(", ");

                  const payload = {
                    title: doctorForm.title || null,
                    firstname,
                    surname,
                    practicenumber,
                    email: (doctorForm.email || "").trim() || null,
                    contactnumber: contactnumber || null,
                    practicecontactnumber: practicecontactnumber || null,
                    practiceaddress: practiceaddress || null,
                    postaladdress: postaladdress || null,
                    speciality: (doctorForm.speciality || "").trim() || null,
                  };

                  if (doctorForm.practiceType === "Other" && (doctorForm.practiceTypeOther || "").trim()) {
                    payload.practicetype = doctorForm.practiceTypeOther.trim();
                  } else if (doctorForm.practiceTypeId) {
                    payload.practicetypeid = doctorForm.practiceTypeId;
                  }

                  try {
                    setSaving(true);
                    if (practitionerId) {
                      await updatePractitioner(practitionerId, payload);
                    } else {
                      await createPractitioner(payload);
                    }
                    setSaving(false);
                    if (typeof onSaved === "function") onSaved();
                  } catch (err) {
                    setSaving(false);
                    setErrorMsg(err?.message || "Network error while saving");
                  }
                }}
              >
                Save
              </Button>
            )}
            {errorMsg ? (
              <div className={popupStyles.errorMessage}>{errorMsg}</div>
            ) : null}
            {showDisable && !readOnly && (
              <Button
                variant="primary"
                className={
                  disableLabel === "Enable"
                    ? pageStyles.enableBtn
                    : pageStyles.modalDisableBtn
                }
                noHover
                onClick={() => {
                  if (typeof onRequestDisable === 'function') onRequestDisable();
                }}
              >
                {disableLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}